export default __webpack_public_path__ + "static/media/series_icon_black.45b333f5.svg";